import React from "react";
import { Link } from "react-router-dom";

const Paginate = ({
  pages,
  page,
  isAdmin = false,
  keyword = "",
  isOrder = false,
  isUserList = false,
  isOrderProfile = false,
}) => {
  if (!pages || pages <= 1) return null;

  const buildPath = (p) => {
    if (isOrderProfile) return `/profile/${p}`;
    if (!isAdmin) return keyword ? `/search/${keyword}/page/${p}` : `/page/${p}`;
    if (isOrder) return `/admin/orderlist/${p}`;
    if (isUserList) return `/admin/userlist/${p}`;
    return `/admin/productlist/${p}`;
  };

  return (
    <nav className="hadacy-paginate" aria-label="Paginación">
      <Link
        to={buildPath(1)}
        className="hadacy-paginate__edge"
        aria-disabled={page === 1}
      >
        Primero
      </Link>

      {[...Array(pages).keys()].map((x) => {
        const p = x + 1;
        const isActive = p === page;
        return (
          <Link
            key={p}
            to={buildPath(p)}
            aria-current={isActive ? "page" : undefined}
            className={
              "hadacy-paginate__page" +
              (isActive ? " hadacy-paginate__page--active" : "")
            }
          >
            {p}
          </Link>
        );
      })}

      <Link
        to={buildPath(pages)}
        className="hadacy-paginate__edge"
        aria-disabled={page === pages}
      >
        Último
      </Link>

      <style>{`
        .hadacy-paginate {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: 0.4rem;
          margin: 2.5rem 0 1rem;
          font-family: 'Jost', system-ui, sans-serif;
        }
        .hadacy-paginate a,
        .hadacy-paginate a:visited {
          text-decoration: none;
        }
        .hadacy-paginate__page,
        .hadacy-paginate__edge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 2.4rem;
          padding: 0 0.95rem;
          border: 1px solid rgba(184, 147, 58, 0.22);
          background: #faf7f2;
          color: #7a6e62;
          font-weight: 400;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          transition: transform 0.25s ease, color 0.25s ease,
            background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
          box-shadow: 0 4px 12px rgba(26, 20, 16, 0.03);
        }
        .hadacy-paginate__page {
          min-width: 2.4rem;
          border-radius: 999px;
          font-size: 0.78rem;
        }
        .hadacy-paginate__edge {
          border-radius: 999px;
          font-size: 0.68rem;
          letter-spacing: 0.2em;
          padding: 0 1.1rem;
        }
        .hadacy-paginate__page:hover,
        .hadacy-paginate__edge:hover {
          color: #1a1410;
          background: #ffffff;
          border-color: rgba(184, 147, 58, 0.6);
          transform: translateY(-1px);
          box-shadow: 0 8px 18px rgba(26, 20, 16, 0.08);
        }
        .hadacy-paginate__page--active,
        .hadacy-paginate__page--active:hover {
          background: #1a1410;
          color: #d4af6a;
          border-color: #1a1410;
          transform: none;
          box-shadow: 0 10px 22px rgba(26, 20, 16, 0.22);
        }
        @media (max-width: 480px) {
          .hadacy-paginate { gap: 0.3rem; margin-top: 1.75rem; }
          .hadacy-paginate__page,
          .hadacy-paginate__edge {
            height: 2.1rem;
            padding: 0 0.7rem;
            font-size: 0.7rem;
          }
          .hadacy-paginate__page { min-width: 2.1rem; }
          .hadacy-paginate__edge { font-size: 0.6rem; padding: 0 0.85rem; }
        }
      `}</style>
    </nav>
  );
};

export default Paginate;
